<template>
  <div class="font-sans">
    <NuxtLoadingIndicator />
    <div class="relative z-0 flex min-h-screen flex-col text-primary">
      <div
        class="relative flex flex-grow items-start justify-center overflow-hidden px-4 md:px-6 xl:px-[100px]"
        @click="activeBody"
      >
        <div class="w-full">
          <slot />
        </div>
      </div>

      <!-- <LazyLayoutsNewsletter /> -->
      <LazyLayoutsNewsletterUser />
    </div>
  </div>
</template>

<script setup>
const activeBody = () => {
  document.body.classList.remove('overflow-hidden')
  document.body.classList.remove('h-full')
}
</script>
